import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// To measure performance, pass a callback to reportWebVitals or send to an analytics endpoint.
// See https://bit.ly/CRA-vitals
reportWebVitals();
